module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-body",
    style: (_vm.height)
  }, [_c('table', {
    staticClass: "table",
    attrs: {
      "id": _vm.id
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-center"
  }, _vm._l((_vm.names), function(val, key, index) {
    return _c('th', {
      key: key,
      attrs: {
        "id": _vm.id + '-name-' + key
      }
    }, [_vm._v("\n          " + _vm._s(val.name) + "\n          "), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (val.icon),
        expression: "val.icon"
      }],
      staticClass: "fa",
      class: val.icon,
      attrs: {
        "aria-hidden": "true"
      }
    })])
  }), 0)]), _vm._v(" "), _vm._l((_vm.data), function(row, key, index) {
    return _c('tbody', {
      key: key,
      attrs: {
        "id": _vm.id + '-body'
      }
    }, [_c('tr', {
      staticClass: "info"
    }, [_c('td', [_vm._v(" " + _vm._s(row.ducto) + " ")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(row.estacion) + " ")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(row['00'] || '0000'))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(row['01'] || '0000'))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(row['02'] || '0000'))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(row['03'] || '0000'))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(row['04'] || '0000'))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(row['05'] || '0000'))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(row['06'] || '0000'))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(row['07'] || '0000'))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(row['08'] || '0000'))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(row['09'] || '0000'))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(row['10'] || '0000'))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(row['11'] || '0000'))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(row['12'] || '0000'))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(row['13'] || '0000'))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(row['14'] || '0000'))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(row['15'] || '0000'))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(row['16'] || '0000'))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(row['17'] || '0000'))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(row['18'] || '0000'))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(row['19'] || '0000'))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(row['20'] || '0000'))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(row['21'] || '0000'))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(row['22'] || '0000'))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(row['23'] || '0000'))])])])
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78745261","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Campo/CampoTable.vue
// module id = 1710
// module chunks = 6